import React from 'react';
import './Demos.css';
import { Link } from 'react-router-dom';

const Demos = () => {
    return (
        <section className="demos" id="demos">
            <div className="container">
                <div className="demos-header">
                    <div>
                        <div className="eyebrow rv in">Demos interactivas</div>
                        <h2 className="s-title rv in d1">Pruébalo antes<br />de decidir</h2>
                    </div>
                    <p className="s-sub rv in d2" style={{ textAlign: 'right' }}>
                        Experimenta el poder de la IA aplicada a tu industria, sin compromiso ni instalaciones.
                    </p>
                </div>

                <div className="demos-grid">
                    {/* Demo 1: Disponible (Activa) */}
                    <div className="demo-card rv in">
                        <div className="demo-badge demo-badge-live">Disponible ahora</div>
                        <div className="demo-icon demo-icon-live">
                            <svg viewBox="0 0 26 26" fill="none" stroke="#1022C8" strokeWidth="1.6" strokeLinecap="round">
                                <rect x="3" y="3" width="20" height="14" rx="2"/>
                                <path d="M8 21h10M13 17v4"/>
                                <path d="M8 10l3 3 6-6"/>
                            </svg>
                        </div>
                        <div className="demo-name">Demo Inmobiliarias</div>
                        <div className="demo-desc">
                            Asistente de IA para agencias inmobiliarias — responde consultas de propiedades, agenda visitas y gestiona leads de forma automática 24/7. Integración con WhatsApp y web.
                        </div>
                        <Link to="/demos/inmobiliarias" className="demo-link">
                            Explorar demo
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </Link>
                    </div>

                    {/* Demo 2: Próximamente (Inactiva) */}
                    <div className="demo-card rv in d1" style={{ opacity: 0.65 }}>
                        <div className="demo-badge demo-badge-soon">Próximamente</div>
                        <div className="demo-icon demo-icon-soon">
                            <svg viewBox="0 0 26 26" fill="none" stroke="var(--g500)" strokeWidth="1.6" strokeLinecap="round">
                                <path d="M13 3L3 8v5c0 5.5 4.4 10.7 10 12 5.6-1.3 10-6.5 10-12V8L13 3z"/>
                                <path d="M9 13l3 3 5-5"/>
                            </svg>
                        </div>
                        <div className="demo-name demo-name-soon">Demo Industrial</div>
                        <div className="demo-desc">
                            Plataforma de mantenimiento predictivo para el sector industrial — detecta fallos antes de que ocurran y optimiza el ciclo de vida de los equipos.
                        </div>
                    </div>

                    {/* Demo 3: Próximamente (Inactiva) */}
                    <div className="demo-card rv in d2" style={{ opacity: 0.65 }}>
                        <div className="demo-badge demo-badge-soon">Próximamente</div>
                        <div className="demo-icon demo-icon-soon">
                            <svg viewBox="0 0 26 26" fill="none" stroke="var(--g500)" strokeWidth="1.6" strokeLinecap="round">
                                <rect x="2" y="7" width="22" height="13" rx="2"/>
                                <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
                                <path d="M8 14h2M12 14h6"/>
                            </svg>
                        </div>
                        <div className="demo-name demo-name-soon">Demo Logística</div>
                        <div className="demo-desc">
                            Optimización de rutas, gestión inteligente de almacenes y análisis predictivo de demanda — todo en una plataforma unificada.
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demos;